import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NotificacionesPage } from './notificaciones';
import { ComponentsModule } from '../../components/components.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    NotificacionesPage,
  ],
  imports: [
    IonicPageModule.forChild(NotificacionesPage),
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class NotificacionesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/notificaciones/notificaciones.module.ts